
export var myModal = new bootstrap.Modal(document.getElementById("exampleModal"), {});

export function infoLayer(layer) {

  $.get('./assets/data/' + layer.get('infoContent') + '.html', function (data) {
    $('.modal-body').html(data)
  })
  $('.modal-title').html(layer.get('infoTitle') + '<br/>');
  myModal.show();
}



$(document).ready(function () {
  $('.ol-control.ol-layerswitcher>button').on('click touchstart', function () {
    $('.ol-control.ol-layerswitcher>button').toggleClass('changed');
  });
});


$('.tutorial').click(function () {
  $('.modal-title').html('Samouczek<br/>');
  $('.modal-footer').html('');

  $.get('./assets/data/tutorial.html', function (data) {
    $('.modal-body').html(data)
    myModal.show();
  })

});



//----------------------------------------- mobile offcanvas-------------------------------------------------
if ($(window).width() < 768) { $('.offcanvas').removeClass('show'); }


//----------Update offcanvas width depending on layers name
function updateOffcanvasWidth() {
  let span = document.querySelectorAll(".ol-layerswitcher .panel .li-content label span"); //get layers span
  let spanWidth = 0; //store the widest span

  //find the widest span
  span.forEach(label => {
      let width = label.scrollWidth;
      if (width > spanWidth) {
        spanWidth = width;
      }
  });

  const offcanvasWidth = 24 * 16; 
  let newWidth = spanWidth > 0 ? Math.max(offcanvasWidth, spanWidth + 150) : offcanvasWidth;

  let offcanvas = document.getElementById("offCanvasLeft");

  if (offcanvas.style.width !== `${newWidth}px`) {
      offcanvas.style.width = `${newWidth}px`;
  }

  span.forEach(label => {
      label.style.maxWidth = `${newWidth}px`;
  });
}

document.addEventListener("DOMContentLoaded", () => {
  updateOffcanvasWidth();

  document.querySelector(".ol-layerswitcher").addEventListener("click", () => {
      setTimeout(updateOffcanvasWidth, 0);
  });
  
});

//----------reset offcanvas width after clicking on Legend
document.addEventListener("DOMContentLoaded", () => {
  
  let offcanvas = document.getElementById("offCanvasLeft");

  function resetOffcanvasWidth() {
    offcanvas.style.width = "24em";
  }

  let lsButton = document.querySelector(".nav-link.active");
  let legend = document.querySelector(".nav-link.legend");


  lsButton.addEventListener("click", updateOffcanvasWidth);
  legend.addEventListener("click", resetOffcanvasWidth);

});


//---------------------------------------------Cookie banner----------------------------------------------------------

/* Javascript to show and hide cookie banner using localstorage */
/* Shows the Cookie banner */
function showCookieBanner() {
  let cookieBanner = document.getElementById("cb-cookie-banner");
  cookieBanner.style.display = "block";
}

/* Hides the Cookie banner and saves the value to localstorage */
function hideCookieBanner() {
  localStorage.setItem("cb_isCookieAccepted", "yes");
  let cookieBanner = document.getElementById("cb-cookie-banner");
  cookieBanner.style.display = "none";
}

/* Checks the localstorage and shows Cookie banner based on it. */
function initializeCookieBanner() {
  let isCookieAccepted = localStorage.getItem("cb_isCookieAccepted");
  if (isCookieAccepted === null) {
    localStorage.setItem("cb_isCookieAccepted", "no");
    showCookieBanner();
  }
  if (isCookieAccepted === "no") {
    showCookieBanner();
  }
}

// Assigning values to window object
window.onload = initializeCookieBanner();
window.cb_hideCookieBanner = hideCookieBanner;